// Use $ instead of $ without replacing global $
(function ($) {

  function setGrid() {
    var $winWidth = $(window).width();

    if ($winWidth > 767) {
      // setTimeout(function () {
      //   var content_Height = $('body .intro-with-tabs .image-tab-wrapper .col-two.tab-details .tabs .tab-pane.active').outerHeight();
      //   $('.intro-with-tabs .image-tab-wrapper .col-two.tab-details').animate({'height': content_Height + "px"});
      // }, 500);

      setTimeout(function () {
        var divCount = $('.intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab').length;
        var img_height = $('.intro-with-tabs .image-tab-wrapper .col-two.tab-details').outerHeight();

        $('.intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab').animate(({'height': img_height / divCount - 10 + 'px'}));
      }, 800);
    } else {
      $('.intro-with-tabs .image-tab-wrapper .col-two').removeAttr('style');
    }
  }

  $(document).ready(function () {
    // $('.intro-with-tabs .image-tab-wrapper .col-two').matchHeight();


    $('.intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab').click(function () {
      var tab_id = $(this).attr('data-tab');

      $('.intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab').removeClass('active');
      $('.intro-with-tabs .image-tab-wrapper .col-two.tab-details .tabs .tab-pane').removeClass('active show');

      $(this).addClass('active');
      $("#" + tab_id).addClass('active show');

      setGrid();
    });

    var tab_item = $('body .intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab').length;
    if (tab_item <= 1) {
      $('body .intro-with-tabs .image-tab-wrapper').addClass('no-item');
    }
    else {
      $('body .intro-with-tabs .image-tab-wrapper').addClass('has-item');
    }


    // if ($(".intro-with-tabs").length > 0) {
    //   $(".intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab").click(function (e) {
    //     var width = $(window).width();
    //     if (width <= 575) {
    //       var nav = $("header"),
    //           nav_height = nav.outerHeight();
    //       e.preventDefault();
    //       $("html, body").animate(
    //           {
    //             scrollTop: $(".intro-with-tabs").offset().top - nav_height + 20
    //           },
    //           "slow"
    //       );
    //       return false;
    //     }
    //   });
    // }
  });


  $(window).on('load resize', function () {

    setGrid();


    // if (($winWidth < 1200)) {
    //     $('.intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab').css(({'height': img_height / divCount - 14 + 'px'}));
    // } else {
    //     $('.intro-with-tabs .image-tab-wrapper .col-two.tab-head .image-tab').removeAttr('style');
    // }

  });

})(jQuery);
